import { fromJS } from 'immutable';

export const MARIGRAM_SEARCH_TOGGLE_SECTION = 'MARIGRAM_SEARCH_TOGGLE_SECTION';

const initialState = fromJS({
  marigramSourceInformationExpanded: true,
  marigramLocationInformationExpanded: true,
  marigramParametersEffectsInformationExpanded: true,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const marigramSearchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case MARIGRAM_SEARCH_TOGGLE_SECTION:
      return state.set(action.section, !state.get(action.section));
    default:
      return state;
  }
};
